export default "__VITE_ASSET__BQnp$fsa__"